export function currencyFormat(num) {
    return '£' + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
 }

 export function checking_null_undefined(array) {
    if (array === null || array === undefined) {
        return [];
    }
    return array;
}